import { render } from "./SegundoNivel.vue?vue&type=template&id=ed4d8594"
import script from "./SegundoNivel.vue?vue&type=script&lang=js"
export * from "./SegundoNivel.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__